export const processableEventBus = ({ processManagerDefinitions, queryBus, commandBus }) => async (domainEvents) => domainEvents.forEach((domainEvent) => {
    (processManagerDefinitions[domainEvent.name] || []).forEach((processManagerDefinition) => {
        const [processManager, dependencies] = processManagerDefinition;
        processManager({
            ...dependencies,
            queryBus,
            commandBus: commandBus(),
        })(domainEvent);
    });
});
